import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { API } from './constants';

export type AppUpdateType = 'update' | 'announcement';
export type AppUpdateDisplayMode = 'inline' | 'popup';

export type AppUpdate = {
	_id: string;
	title: string;
	description: string;
	type: AppUpdateType;
	displayMode?: AppUpdateDisplayMode;
	imageObjectKey?: string;
	imageUrl?: string;
	imageThumbUrl?: string;
	link?: string;
	active: boolean;
	order?: number;
	/** Oferta: sale en el carrusel (escritorio) y en la cinta (móvil) aunque ya se haya visto. */
	isOffer?: boolean;
	read?: boolean;
	createdAt: string;
	updatedAt: string;
};

export type AppUpdatePagination = {
	totalElements: number;
	hasNextPage: boolean;
	nextPage: number;
	previousPage: number;
	lastPage: number;
};

export type AppUpdatesResponse = {
	elements: AppUpdate[];
	pagination: AppUpdatePagination;
};

@Injectable({ providedIn: 'root' })
export class AppUpdatesService extends ApiService {
	getMy(params?: { page?: number; limit?: number; type?: AppUpdateType }) {
		const query = new URLSearchParams();
		if (params?.page) query.set('page', String(params.page));
		if (params?.limit) query.set('limit', String(params.limit));
		if (params?.type) query.set('type', params.type);

		const qs = query.toString();
		const url = `${API.getMyAppUpdates}${qs ? `?${qs}` : ''}`;
		return this.get<AppUpdatesResponse>(url);
	}

	getMyUnreadCount(type?: AppUpdateType) {
		const qs = type ? `?type=${type}` : '';
		return this.get<number>(`${API.getMyAppUpdatesUnreadCount}${qs}`);
	}

	getPopups() {
		return this.get<AppUpdate[]>(API.getMyAppUpdatePopups);
	}

	/** Active offers for this user (already seen or not), newest first. */
	getOffers() {
		return this.get<AppUpdate[]>(API.getMyAppUpdateOffers);
	}

	markAsRead(id: string) {
		return this.patch<{ success: boolean }>(`${API.markAppUpdateAsRead}/${id}/read`);
	}

	/** The popup was closed; `clicked` = the user pressed «Ver más». */
	markPopupSeen(id: string, clicked: boolean) {
		return this.post<{ success: boolean }>(`${API.markAppUpdateAsRead}/${id}/popup-seen`, { body: { clicked } });
	}

	markAllAsRead(type?: AppUpdateType) {
		const qs = type ? `?type=${type}` : '';
		return this.patch<{ modifiedCount: number }>(`${API.markAllMyAppUpdatesAsRead}${qs}`);
	}
}
